import { useQuery } from '@apollo/client';
import { useEffect } from 'react';

import { POLLING_INTERVAL_MS } from '@neo.tax/shared/constants';
import { IS_VERSION_OUTDATED, IsVersionOutdatedQuery } from '@neo.tax/shared/graphql';
import { VersionGuardState } from '@neo.tax/shared/state';

export const useIsVersionOutdatedPoll = (): void => {
  const { data, startPolling, stopPolling } = useQuery<IsVersionOutdatedQuery>(IS_VERSION_OUTDATED, {
    pollInterval: POLLING_INTERVAL_MS,
  });

  useEffect(() => {
    startPolling(POLLING_INTERVAL_MS);
    VersionGuardState.updateIsVersionOutdated(!!data?.isVersionOutdated);
    // on unmount, stop polling
    return (): void => {
      stopPolling();
    };
  }, [data?.isVersionOutdated, startPolling, stopPolling]);
};
